import api from "../utils/api";
export default {
  namespaced: true,
  state: { templates: [], campaigns: [], segments: [] },
  mutations: {
    SET_TEMPLATES: (state, payload) => {
      state.templates = payload.templates;
    },
    SET_CAMPAIGNS: (state, payload) => {
      state.campaigns = payload.campaigns;
    },
    SET_SEGMENTS: (state, payload) => {
      state.segments = payload.segments;
    }
  },
  actions: {
    getTemplates(context) {
      return api.get(`marketing/template`).then(response => {
        context.commit("SET_TEMPLATES", response);
        return response;
      });
    },
    createTemplate(context, payload) {
      return api.post(`marketing/template`, payload.requestParams);
    },
    resyncStatus() {
      return api.get(`marketing/template/sync`);
    },
    getCampaigns(context, payload) {
      return api
        .get(`marketing/campaign?page=${payload.page}`)
        .then(response => {
          context.commit("SET_CAMPAIGNS", response);
          return response;
        });
    },
    getSegments(context) {
      return api.get(`marketing/segments`).then(response => {
        context.commit("SET_SEGMENTS", response);
        return response;
      });
    },
    createCampaign(context, payload) {
      return api.post(`marketing/campaign`, payload.requestParams);
    },
    reviewCampaign(context, payload) {
      return api.post(`marketing/campaign/review`, payload.requestParams);
    },
    getUploadUrl(context, payload) {
      return api.post(`marketing/campaign/upload`, payload.requestParams);
    },
    submitCampaign(context, payload) {
      return api.post(`marketing/campaign/review/${payload.campaignId}`);
    },
    deleteCampaign(context, payload) {
      return api.delete(`marketing/campaign/review/${payload.campaignId}`);
    },
    getMessageLog(context, payload) {
      return api.get(`marketing/messagelog/?page=${payload.page}`);
    },
    getCampaignReport(context, payload) {
      return api.get(`marketing/campaign/report/${payload.campaignId}`);
    },
    getOrderStats(context, payload) {
      return api.get(`marketing/campaign/orders/${payload.campaignId}`);
    }
  },
  getters: {
    getTemplates: state => state.templates,
    getSegments: state => state.segments,
    getCampaigns: state => state.campaigns
  }
};
